<template>
    <Header
        :page-title="title"
    ></Header>
    <div class="page-content cus-content">
        <div class="li-header">三农动态</div>
        <div class="li-list" v-if="rtData.listData.length > 0">
            <div class="li-list-row" v-for="(item, i) in rtData.listData" :key="i">
                <div class="li-list-row-dodd"></div>
                <div class="li-list-row-content" @click="handleClick(item.id)">
                    <div>{{ item.title }}</div>
                    <div>{{ item.createTime.split(' ')[0] }}</div>
                </div>
            </div>
        </div>
    </div>
    <pageTool></pageTool>
</template>

<script>
import Header from "@/components/SNInfo/Header"
import pageTool from "@/components/nav/pageTool"
import { onMounted, reactive } from 'vue'
import { useRouter } from "vue-router"
const banner = require('@/assets/img/page_banner_0.png')
import {getPolicyList} from '@/api/policy'
export default {
    name: "Home",
    setup() {
        const router = useRouter()
        const title = {
            cn: '三农动态',
            en: 'The Three Rural Trend',
            hasSearch: false,
            titleStyle: true,
            banner
        }
        // alert(document.body.clientWidth)
        // alert(document.body.clientHeight)
        const rtData = reactive({
            listData: []
        })
        const getPolicyListData = async () => {
            const params = {
                "current": 1,
                "model": {
                    "secondCategoryId": 100001,
                },
                "size": 100,
            }
            const data = await getPolicyList(params)
            rtData.listData = data.records
        }
        const handleClick = (id) => {
            // const data = await getPolicyDetail(id)
            // router.push({ name: 'ArticleDetails', query: { id: id, titleCn: title.cn, titleEn: title.en, title: data.title, text: data.text, img: data.imgs, resources: JSON.stringify(data.resources)}})
            router.push({ name: 'ArticleDetails', query: { id: id, titleCn: title.cn, titleEn: title.en, type:'1'}})
        }
        onMounted(() => {
            getPolicyListData()
        })
        return {
            title,
            rtData,
            handleClick,
            getPolicyListData
        }
    },
    components: {
        Header,
        pageTool
    }
}
</script>

<style scoped lang="stylus">
    .page-content {
        padding 20px 30px
    }
</style>